import imgQuiz from '../../../../img/quizImg.png?width=200px';
import noTimerImg from '../../../../img/noTimer.png?width=30px';
import timerImg from '../../../../img/timer.png?width=30px';
import I18n from '../../../i18n';

export default function initialPage():string{
    return `
        <div id="quiz-inital-page">
            <p class="desc-text">${I18n.apply("Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República")}</p>
            <div class="container-option">
                <button type="button" class="btn-raking">Ranking</button>
                <img class="main-img" src="${imgQuiz}" alt="img-quiz">
                <div class="dropdown-mode">
                    <div class="current">
                        <span class="intial-select">
                            ${I18n.apply("Modo")}
                        </span>
                    </div>
                    <div class="options d-none">
                        <span class="option-item" data-quiz-mode="15sec">
                            <img src="${timerImg}" class="item-option" alt="img-mode-timer">
                            ${I18n.apply("15 segundos","label", "item-option")}
                        </span>
                        <span class="option-item" data-quiz-mode="classic">
                            <img src="${noTimerImg}" class="item-option" alt="img-mode-no-timer">
                            ${I18n.apply("Clássico","label", "item-option")}
                        </span>
                    </div>
                </div>
            </div>
            <button type="button" class="btn-play">${I18n.apply("Jogar")}</button>
        </div>
    `;
}